export const PROMOTION_BTN_TYPE = {
  LINK: 'link',
  BASKET: 'basket'
};

// Kill-switch for the -10% first-order promo: popup on the home page + discount in checkout.
// Off since 08.2026 — the backend stopped applying the discount, so the frontend must not promise or count it.
export const IS_FIRST_ORDER_DISCOUNT_ENABLED = false;
